import { RouterType } from '@moonpig/web-core-routing'
import { ApplicableFilter, SearchFilter } from '../../services/types/services'
import {
  getHistoryPageSyncDestinationKey,
  skipNextHistoryPageSync,
} from './skipNextHistoryPageSync'

type Props = {
  router: RouterType | null
  selectedFilters: ApplicableFilter[]
  preAppliedFilters: SearchFilter[]
  department?: string
  mostRecentSearchTerm?: string
  usePageNavigation?: boolean
}

export const updateRoute = ({
  router,
  selectedFilters,
  department,
  preAppliedFilters,
  mostRecentSearchTerm,
  usePageNavigation = false,
}: Props) => {
  if (!router) return

  const { name, params } = router.getCurrentRoute<'content' | 'search'>()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { page, filters, d, ...existingQuery } = params

  const updatedFilters = selectedFilters?.length
    ? selectedFilters
        .map(filter =>
          filter.__typename === 'IntegerFilter'
            ? `${filter.parent}:${filter.integerKey}`
            : `${filter.parent}:${filter.id}`,
        )
        .join('.')
    : undefined

  const isCurrentDepartment = department?.toLowerCase() === d?.toLowerCase()

  const shouldShallowReplace =
    updatedFilters !== filters && (!department || isCurrentDepartment)

  const hasASuggestionBeenApplied =
    preAppliedFilters?.length > 0 && preAppliedFilters.some(f => f.suggestion)

  const newParams = {
    ...existingQuery,
    ...(usePageNavigation ? { offset: undefined } : {}),
    ...(updatedFilters ? { filters: updatedFilters } : {}),
    ...(department ? { d: department.toLowerCase() } : {}),
    ...(hasASuggestionBeenApplied && name === 'search'
      ? {
          suggestion: (existingQuery as { suggestion?: string }).suggestion,
        }
      : {
          suggestion: undefined,
          q: mostRecentSearchTerm || (existingQuery as { q?: string }).q,
        }),
    smartRedirection: undefined,
  }

  if (usePageNavigation) {
    skipNextHistoryPageSync(
      getHistoryPageSyncDestinationKey(
        name,
        newParams as unknown as Record<string, unknown>,
      ),
    )
  }

  return router.replace({
    name,
    params: newParams,
    shallow: shouldShallowReplace,
  })
}
